import DecryptPage from "./DecryptPage";

export default DecryptPage;
